import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import styles from './AddPhotoFeedbackPage.module.scss';
import trashIcon from '../../constants/images/trash-icon.svg';
import {feedbackCleanerActions} from '../../store/slices/feedbackCleanerSlice';
import ModalPreviewSelectedPhoto from '../ModalPreviewSelectedPhoto/ModalPreviewSelectedPhoto';
import {modalPreviewSelectedPhotoActions} from "../../store/slices/modalPreviewSelectedPhotoSlice";
import {feedbackCustomerActions} from "../../store/slices/feedbackCustomerSlice";
import {resolveMediaUrl} from "../../configs/urls";
import toast from "react-hot-toast";
import {compressImage} from "../../utils/imageCompression";

const AddPhotoFeedbackPage = ({type}) => {
    const [photoForPreview, setPhotoForPreview] = useState(null);
    const [error, setError] = useState("");

    const {photos_completed_order: photosCleaner} = useSelector((state) => state.feedbackCleaner);
    const {photos_completed_order: photosCustomer} = useSelector((state) => state.feedbackCustomer);
    const {isPreviewOpen} = useSelector((state) => state.modalPreviewSelectedPhoto);
    const {photos, qr_code} = useSelector(state => state.qrCode);

    const dispatch = useDispatch();

    const handleAddPhoto = () => {
        document.getElementById('fileInput').click();
    };

    const handleGetPhotosFromInput = async (e) => {
        const files = e.target.files;

        if (type === 'customer') {
            if (files.length > 0) {
                const updatedFiles = [...photosCustomer];

                for (const file of files) {
                    if (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg') {
                        if (file.size <= 20 * 1024 * 1024) {
                            // Shrink in the browser before upload; falls back to
                            // the original file if compression fails.
                            updatedFiles.push(await compressImage(file));
                        } else {
                            setError(`Файл ${file.name} перевищує максимальний розмір (20 МБ)`);
                        }
                    } else {
                        setError(`Формат файлу ${file.name} не підтримується. Підтримувані формати: PNG, JPG, JPEG`);
                    }
                }

                dispatch(feedbackCustomerActions.setPhotosCompletedOrder(updatedFiles));
            }
        } else {
            if (files.length > 0) {
                const updatedFiles = [...photosCleaner];

                for (const file of files) {
                    if (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg') {
                        if (file.size <= 20 * 1024 * 1024) {
                            // Shrink in the browser before upload; falls back to
                            // the original file if compression fails.
                            updatedFiles.push(await compressImage(file));
                        } else {
                            setError(`Файл ${file.name} перевищує максимальний розмір (20 МБ)`);
                        }
                    } else {
                        setError(`Формат файлу ${file.name} не підтримується. Підтримувані формати: PNG, JPG, JPEG`);
                    }
                }

                dispatch(feedbackCleanerActions.setPhotosCompletedOrder(updatedFiles));
            }
        }
    };

    const handleDeleteSelectedPhoto = (event, index) => {
        event.stopPropagation();

        if (type === 'customer') {
            const updatedFiles = [...photosCustomer];
            updatedFiles.splice(index, 1);

            dispatch(feedbackCustomerActions.setPhotosCompletedOrder(updatedFiles));
        } else {
            const updatedFiles = [...photosCleaner];
            updatedFiles.splice(index, 1);

            dispatch(feedbackCleanerActions.setPhotosCompletedOrder(updatedFiles));
        }
    };

    const handleOpenPreview = (type, file) => {
        if (type !== 'qr-code') {
            setPhotoForPreview(URL?.createObjectURL(file));
        } else {
            setPhotoForPreview(resolveMediaUrl(file));
        }

        dispatch(modalPreviewSelectedPhotoActions.openPreview('AddPhotoFeedbackPage'));
    }

    useEffect(() => {
        if (error) {
            toast.error(error, {id: "error"});
            setError(null);
        }
    }, [error]);

    useEffect(() => {
        return () => {
            toast.remove("error");
        }
    }, []);

    return (
        <div className={styles.addPhotoWrapper}>
            <p className={styles.addPhotoWrapper_title}>Додати фото <sup>*</sup></p>

            <div className={styles.addPhotoWrapper_addPhotoContainer}>
                {photos?.length === 0 ? <div className={styles.addPhotoWrapper_addPhotoContainer_buttons}>
                        <button onClick={handleAddPhoto} className={styles.addFullWidth}>
                            Додати фото
                            <span>Формат: PNG, JPG, JPEG (Макс. 20мб)</span>
                        </button>
                        <input
                            onChange={handleGetPhotosFromInput}
                            type="file"
                            id="fileInput"
                            style={{display: 'none'}}
                            multiple // Allow multiple file selection
                        />

                        <div className={styles.addPhotoWrapper_addPhotoContainer_buttons_add}>
                            {type === 'customer' ?
                                <>
                                    {photosCustomer?.map((file, index) => (
                                        <div
                                            onClick={() => handleOpenPreview('usual', file)}
                                            key={index} className={styles.add}
                                            style={{backgroundImage: `url(${URL.createObjectURL(file)})`}}
                                        >
                                            <div onClick={(event) => handleDeleteSelectedPhoto(event, index)}>
                                                <img src={trashIcon} alt="trash-icon"/>
                                            </div>
                                        </div>
                                    ))}
                                    {Array.from({length: 4 - photosCustomer?.length})?.map((_, index) => (
                                        <button key={index} onClick={handleAddPhoto} className={styles.add}>
                                            +
                                        </button>
                                    ))}</> :
                                <>
                                    {photosCleaner?.map((file, index) => (
                                        <div
                                            onClick={() => handleOpenPreview('usual', file)}
                                            key={index} className={styles.add}
                                            style={{backgroundImage: `url(${URL.createObjectURL(file)})`}}
                                        >
                                            <div onClick={(event) => handleDeleteSelectedPhoto(event, index)}>
                                                <img src={trashIcon} alt="trash-icon"/>
                                            </div>
                                        </div>
                                    ))}
                                    {Array.from({length: 4 - photosCleaner?.length})?.map((_, index) => (
                                        <button key={index} onClick={handleAddPhoto} className={styles.add}>
                                            +
                                        </button>
                                    ))}
                                </>}
                        </div>
                    </div> :
                    <div style={{width: '100%'}} className={styles.addPhotoWrapper_addPhotoContainer_buttons_add}>
                        {photos?.length > 0 && photos?.map((file, index) => (
                            <div
                                onClick={() => handleOpenPreview('qr-code', file)}
                                key={index} className={styles.add}
                                style={{backgroundImage: `url(${resolveMediaUrl(file)})`}}
                            >
                            </div>
                        ))}
                    </div>}

                <div
                    className={`${styles.addPhotoWrapper_addPhotoContainer_qr} ${
                        (photosCustomer?.length > 0 || photosCleaner?.length > 0 || photos?.length > 0) ? styles.hide : ''
                    }`}
                >
                    <img style={{width: '100%', height: '75%'}} src={`data:image/png;base64,${qr_code}`} alt="qr code"/>
                </div>

                {isPreviewOpen &&
                    <ModalPreviewSelectedPhoto photo={photoForPreview} component={'AddPhotoFeedbackPage'}/>}
            </div>
        </div>
    );
};

export default AddPhotoFeedbackPage;
